<template>
  <ElDialog title="微信支付" v-model="dialogFormVisible" width="550px">
    <template v-if="!orderInfo">
      <ElIcon :size="20" class="is-loading">
        <loading />
      </ElIcon>
      <br />
      <br />
      <span>创建订单中</span>
    </template>
    <img v-else :src="orderInfo.qrcode" alt="" />
  </ElDialog>
</template>
<script>
import goodList from '@/pages/goodList'
import { getCookie } from '@/utils/cookie'
import { ElDialog, ElIcon } from 'element-plus'
import { Loading } from '@element-plus/icons'
import { goodsOrder, getPayInof } from '@/api/payWx'
import { ElMessage } from 'element-plus'
export default {
  components: {
    ElDialog,
    ElIcon,
    Loading,
  },
  data() {
    return {
      goodList,
      goodsInfo: null,
      dialogFormVisible: false,
      orderInfo: null,
      myInterval: null,
    }
  },
  beforeUnmount() {
    clearInterval(this.myInterval)
  },
  methods: {
    open(id) {
      this.dialogFormVisible = true
      this.goodsInfo = this.goodList.find((item) => item.id === id)
      // 创建商品订单
      this.goodsOrder()
    },
    async goodsOrder() {
      const res = await goodsOrder({
        appid: 'wx43cddada7b553cec', //平台标识
        mobile: getCookie('phone'), //手机号
        description: this.goodsInfo.title, //商品描述
        total: this.goodsInfo.price, //金额, 单位:分
        // total: 1, //金额, 单位:分
        itemId: this.goodsInfo.id, //商品id
      })
      this.orderInfo = res.data
      // 轮询获取支付状态
      this.getPayInof()
    },
    // 获取支付状态
    async getPayInof() {
      this.myInterval = setInterval(async () => {
        const res = await getPayInof(this.orderInfo.outTradeNo)
        if (res.data.tradeState === 'SUCCESS') {
          ElMessage.success('付款成功')
          clearInterval(this.myInterval)
          this.dialogFormVisible = false
          this.$router.push('/orderList')
        }
      }, 1000)
    },
  },
}
</script>
